(function () {
  'use strict';
  var APP_ORIGIN = 'https://shop-health-hub.lovable.app';
  var sessionId = crypto.randomUUID();
  var lastContext = null;
  function sendContext() {
    var frame = document.getElementById('custom-label-builder-frame');
    if (!frame || !frame.contentWindow) return;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var allowed = !!(privacy && privacy.analyticsProcessingAllowed());
    var context = null;
    if (allowed) {
      var params = new URLSearchParams(window.location.search);
      var referrer = '';
      try { referrer = new URL(document.referrer).hostname; } catch (error) { /* No referrer. */ }
      context = { session_id: sessionId, landing_path: window.location.pathname, referrer_host: referrer };
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
        context[key] = (params.get(key) || '').slice(0, 150);
      });
      // First campaign touch is stored only while analytics permission is granted.
      try {
        var stored = JSON.parse(sessionStorage.getItem('custom-label-attribution') || 'null');
        if (stored && stored.session_id && stored.context) {
          sessionId = stored.session_id;
          context.session_id = sessionId;
          // Preserve first campaign touch, but always identify the actual builder page.
          ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','referrer_host'].forEach(function(key) { context[key] = stored.context[key] || context[key] || ''; });
        }
        sessionStorage.setItem('custom-label-attribution', JSON.stringify({ session_id: sessionId, context: context }));
      } catch (error) { /* Storage is optional. */ }
      lastContext = context;
    } else {
      lastContext = null;
      try { sessionStorage.removeItem('custom-label-attribution'); } catch (error) { /* Storage is optional. */ }
    }
    frame.contentWindow.postMessage({ type: 'custom-label-attribution', version: 1, analytics_allowed: allowed, context: context }, APP_ORIGIN);
  }
  document.addEventListener('mouseleave', function(event) {
    var frame = document.getElementById('custom-label-builder-frame');
    if (event.clientY <= 0 && frame && frame.contentWindow) frame.contentWindow.postMessage({ type: 'custom-label-save-prompt', version: 1 }, APP_ORIGIN);
  });
  var builderFrame = document.getElementById('custom-label-builder-frame');
  if (builderFrame) builderFrame.addEventListener('load', sendContext);
  document.addEventListener('visitorConsentCollected', sendContext);
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) sendContext(); });
  }
  window.addEventListener('message', function (event) {
    if (event.origin !== APP_ORIGIN || !event.data) return;
    var builder = document.getElementById('custom-label-builder-frame');
    if (event.data.type === 'custom-label-context-request' && builder && event.source === builder.contentWindow) sendContext();

    if (event.data.type === 'resize' && Number(event.data.height) > 300) {
      var frame = document.getElementById('custom-label-builder-frame');
      if (frame) frame.style.height = Math.min(Number(event.data.height), 6000) + 'px';
    }
    if (event.data.type === 'reviews-resize' && Number(event.data.height) > 120) {
      var reviews = document.getElementById('custom-label-reviews-frame');
      if (reviews) reviews.style.height = Math.min(Number(event.data.height), 2400) + 'px';
    }
  });
  document.querySelectorAll('[data-cl-scroll]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();